export function Gift() {
  return (
    <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 13.3333H28V18.6667H4V13.3333Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <path
        d="M6.66675 18.6667H25.3334V28H6.66675V18.6667Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <path d="M16 13.3333V28" stroke="currentColor" strokeWidth="2.5" />
      <path
        d="M15.9999 13.3333H10.6666C8.45744 13.3333 6.66658 11.5425 6.66658 9.33333C6.66658 7.86057 7.86049 6.66667 9.33325 6.66667C12.2788 6.66667 15.9999 10.3878 15.9999 13.3333Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <path
        d="M16.0001 13.3333H21.3334C23.5426 13.3333 25.3334 11.5425 25.3334 9.33333C25.3334 7.86057 24.1395 6.66667 22.6667 6.66667C19.7212 6.66667 16.0001 10.3878 16.0001 13.3333Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}
